(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["met-eternity-aura"] && !Shopify.designMode) return;
  try {
    



  class MetEternityAura extends HTMLElement {

    connectedCallback() {

      if (this.initialized) return;

      this.initialized = true;

      this.data = JSON.parse(this.querySelector('[data-eternity]').textContent || 'null');

      if (!this.data?.variants?.length) return;

      this.labels = JSON.parse(this.querySelector('[data-labels]').textContent);

      this.english = document.documentElement.lang.startsWith('en');

      this.german = (document.documentElement.lang.startsWith('de') || document.documentElement.lang === 'ar');

      const native = JSON.parse(this.querySelector('[data-native-variants]').textContent);

      this.data.variants.forEach(v=>{const n=native.find(n=>String(n.id)===String(v.id));if(n){v.available=n.available;v.price=n.price/100;}});

      this.selects = Array.from(this.querySelectorAll('[data-choice]'));

      this.selects[0].querySelectorAll('option').forEach(o=>o.textContent=this.metalName(o.value));

      const initial = this.data.variants.find(v => String(v.id) === (new URL(location.href).searchParams.get('variant') || this.dataset.initial)) || this.data.variants[0];

      this.selects.forEach((s,i) => s.value = initial.options[i]);

      this.selects.forEach((s,i) => s.addEventListener('change', () => this.chooseOption(i)));

      this.querySelectorAll('[data-metal]').forEach(r=>r.addEventListener('change',()=>{this.selects[0].value=r.value;this.chooseOption(0);}));

      this.querySelector('[data-show-details]')?.addEventListener('click',()=>{const details=this.querySelector('.met-eternity__info details');details.open=true;details.scrollIntoView({behavior:'smooth',block:'start'});});

      this.classList.add('is-ready');

      this.update();

    }

    metalName(value){return this.labels[{'Platin':'platinum','14 Ayar Beyaz Altın':'white_gold','14 Ayar Sarı Altın':'yellow_gold','14 Ayar Pembe Altın':'rose_gold'}[value]]||value;}

    englishSpec(spec){return spec.en||spec;}

    germanText(key, replacements = {}) {

      let text = this.labels.de[key];

      for (const [token, value] of Object.entries(replacements)) text = text.replaceAll('%' + token + '%', value);

      return text;

    }

    germanDetails(details) {

      const keys = {"Metal":"spec_metal","Design":"spec_design","Total carat option":"spec_total_carat_option","Actual total weight":"spec_actual_total_weight","Average width":"spec_average_width","Diamond type":"spec_diamond_type","Shape":"spec_shape","Colour":"spec_colour","Clarity":"spec_clarity","Marquise diamonds":"spec_marquise_diamonds","Marquise cut grade":"spec_marquise_cut_grade","Round diamonds":"spec_round_diamonds","Setting":"spec_setting","Rhodium plated":"spec_rhodium_plated","Information status":"spec_information_status","Price status":"spec_price_status","Diamond count":"spec_diamond_count","Cut grade":"spec_cut_grade","Ring size":"spec_ring_size","Source item total weight":"spec_source_item_total_weight","Source diamond total weight":"spec_source_diamond_total_weight","Individual diamond weight":"spec_individual_diamond_weight","Ring height":"spec_ring_height","Ring width top":"spec_ring_width_top"};

      const values = {"Floral full eternity":"value_floral_full_eternity","Shared-prong full eternity":"value_shared_prong_full_eternity","Eternity band":"value_eternity_band","Lab grown":"value_lab_grown","D–E (colourless)":"value_colourless","Prong":"value_prong","No":"value_no","Yes":"value_yes","Estimated draft · awaiting verification":"value_estimated_draft","USD 3,195 · reference model price, unverified":"value_unverified_price","Excellent":"value_excellent","Round":"value_round"};

      const metals = {'14K White Gold':'white_gold','14K Yellow Gold':'yellow_gold','14K Rose Gold':'rose_gold','Platinum':'platinum'};

      return details.map(([key,value]) => [this.labels.de[keys[key]] || key, this.labels.de[values[value]] || this.labels[metals[value]] || value.replaceAll(' stones',this.labels.de.value_stones).replaceAll(' total',this.labels.de.value_total).replaceAll('(estimated)',this.labels.de.value_estimated)]);

    }

    germanSpec(spec) {

      const source = this.englishSpec(spec);

      const details = this.germanDetails(source.details);

      const get = key => details.find(([label]) => label === this.labels.de[key])?.[1] || '';

      const exact = {"Aura features round lab-grown diamonds in a shared-prong full eternity design. This first design preview is the 14K white gold, 5 ct, US 3.50 configuration. The source lists 5.00 ct under item details and 5.20 ct under diamond details; both source values are shown separately. Source photographs show ring size US 7.00. Other metal, carat and size combinations are still being verified.":"aura_first_preview","Aura is an eternity band with round lab-grown diamonds. These details apply only to the 14K white gold, 6 ct, US 3.50 configuration.":"aura_specific_configuration"};

      const regular = /^Aura features round lab-grown diamonds set around the band in a shared-prong full eternity design\. Offered in (?:14K white gold|14K yellow gold|14K rose gold|platinum) with a (?:1\/2|1|2|3|4|5|6|7) ct total carat option\.$/;

      const description = exact[source.description] ? this.germanText(exact[source.description]) : regular.test(source.description) ? this.germanText('aura_description',{METAL:get('spec_metal'),CARAT:get('spec_total_carat_option')}) : source.description;

      return {details,description};

    }

    germanMediaText(text) {

      if (typeof text !== 'string') return text || '';

      const exact = {"White gold 5 ct model video":"aura_video_white_five","Lifestyle model reference":"aura_lifestyle_reference","Source photograph shows US 7.00; it is not an exact image of the selected US 3.50 size.":"aura_photo_reference","Source product rotation video; not specific to the selected size.":"aura_rotation_reference","Source lifestyle video; a size reference.":"aura_lifestyle_size_reference"};

      if (exact[text]) return this.germanText(exact[text]);

      return text.replaceAll('14K White Gold',this.labels.white_gold).replaceAll('14K Yellow Gold',this.labels.yellow_gold).replaceAll('14K Rose Gold',this.labels.rose_gold).replaceAll('Platinum',this.labels.platinum).replaceAll('white gold',this.labels.de.white_gold_plain).replaceAll('source reference view',this.labels.de.source_reference_view).replaceAll('view',this.labels.de.view);

    }

    chooseOption(changedIndex){

      const values=this.selects.map(s=>s.value);

      const exact=this.data.variants.find(v=>v.options.every((value,i)=>value===values[i]));

      const note=this.querySelector('[data-option-note]');

      if(note)note.textContent='';

      if(!exact){

        const candidates=this.data.variants.filter(v=>v.options[0]===values[0]);

        const replacement=candidates.find(v=>v.options[1]===values[1])||candidates.find(v=>v.options[2]===values[2])||candidates[0];

        if(replacement){

          this.selects.forEach((s,i)=>s.value=replacement.options[i]);

          if(note)note.textContent=this.german?this.germanText('option_note',{METAL:this.metalName(values[0]),CARAT:replacement.options[1],SIZE:replacement.options[2]}):this.english?`The recorded option for ${this.metalName(values[0])} is ${replacement.options[1]}, ${replacement.options[2]}. Other configurations are still being prepared.`:`${this.metalName(values[0])} için kayıtlı seçenek ${replacement.options[1]}, ${replacement.options[2]}. Diğer birleşimler hazırlanıyor.`;

        }

      }

      this.update();

    }

    update() {

      const values = this.selects.map(s => s.value);

      this.selects.slice(1).forEach((select,offset)=>{

        const index=offset+1;

        select.querySelectorAll('option').forEach(option=>option.disabled=!this.data.variants.some(v=>v.options[0]===values[0]&&v.options[index]===option.value));

      });

      this.querySelectorAll('[data-metal]').forEach(r=>r.checked=r.value===values[0]);

      const v = this.data.variants.find(v => v.options.every((o,i) => o === values[i]));

      const buy = this.querySelector('[data-buy]');

      if (!v) { buy.disabled = true; this.querySelector('[data-selection]').textContent = this.labels.missing; this.querySelector('[data-price]').textContent = ''; this.querySelector('[data-description]').textContent = ''; this.querySelector('[data-details]').replaceChildren(); this.querySelector('[data-gallery]').replaceChildren(); this.querySelector('[data-variant-id]').value = ''; this.gallerySignature = null; return; }

      this.querySelector('[data-variant-id]').value = v.id;

      buy.disabled = !v.available;

      buy.textContent = v.available ? this.labels.add : this.labels.unavailable;

      this.querySelector('[data-price]').textContent = new Intl.NumberFormat(this.german?'de-DE':this.english?'en-US':'tr-TR',{style:'currency',currency:'USD'}).format(v.price);

      this.querySelector('[data-selection]').textContent = [this.metalName(v.options[0]),...v.options.slice(1)].join(' · ') + ' · ' + v.sku;

      const originalSpec = this.data.specs[v.spec];

      const spec=this.german?this.germanSpec(originalSpec):this.english?this.englishSpec(originalSpec):originalSpec;

      this.querySelector('[data-description]').textContent = spec.description + ' '+this.labels.selected_size+': ' + v.options[2] + '.';

      const dl = this.querySelector('[data-details]');

      dl.replaceChildren();

      for (const [label,value] of [...spec.details,[this.labels.size,v.options[2]],[this.labels.sku,v.sku]]) { const dt=document.createElement('dt'),dd=document.createElement('dd');dt.textContent=label;dd.textContent=value;dl.append(dt,dd); }

      const group = this.data.galleries[v.gallery];

      const signature = JSON.stringify(group);

      if (signature !== this.gallerySignature) {

        this.gallerySignature = signature;

        this.renderGallery(group);

      }

      const url=new URL(location.href);url.searchParams.set('variant',v.id);history.replaceState({},'',url);

    }

    renderGallery(group) {

      if(this.german){group=structuredClone(group);group.images.forEach(im=>{im.alt=this.germanMediaText(im.alt_en||im.alt);im.caption=this.germanMediaText(im.caption_en||im.caption);});group.videos.forEach(v=>v.caption=this.germanMediaText(v.caption_en||v.caption));}

      else if(this.english){group=structuredClone(group);group.images.forEach(im=>{im.alt=im.alt_en||im.alt;im.caption=im.caption_en||im.caption;});group.videos.forEach(v=>v.caption=v.caption_en||v.caption);}

      const gallery = this.querySelector('[data-gallery]');

      gallery.replaceChildren();

      this.mediaItems = group.images.slice(0,2).map(image => ({...image,type:'image'}));

      if(group.videos[0])this.mediaItems.push({...group.videos[0],type:'video',poster:group.images[0]?.url});

      this.mediaItems.push(...group.images.slice(2).map(image => ({...image,type:'image'})));

      this.mediaItems.push(...group.videos.slice(1).map(video => ({...video,type:'video',poster:group.images.at(-1)?.url})));

      const stage = document.createElement('div');

      stage.className = 'met-eternity__stage';

      stage.tabIndex = 0;

      stage.setAttribute('role','region');

      stage.setAttribute('aria-label',this.labels.gallery);

      const media = document.createElement('div');

      media.className = 'met-eternity__active-media';

      media.dataset.activeMedia = '';

      stage.append(media);

      for(const [step,label,symbol] of [[-1,this.labels.previous,'‹'],[1,this.labels.next,'›']]) {

        const button = document.createElement('button');

        button.type = 'button';

        button.className = 'met-eternity__arrow ' + (step===-1?'is-prev':'is-next');

        button.setAttribute('aria-label',label);

        button.textContent = symbol;

        button.addEventListener('click',()=>this.showMedia(this.mediaIndex+step));

        stage.append(button);

      }

      const count = document.createElement('span');

      count.className = 'met-eternity__media-count';

      count.dataset.mediaCount = '';

      stage.append(count);

      stage.addEventListener('keydown',event=>{if(event.target!==stage)return;if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();this.showMedia(this.mediaIndex+(event.key==='ArrowRight'?1:-1));}});

      let touchStart;

      stage.addEventListener('touchstart',event=>touchStart=event.touches[0]?.clientX,{passive:true});

      stage.addEventListener('touchend',event=>{const distance=touchStart-event.changedTouches[0]?.clientX;if(Math.abs(distance)>50)this.showMedia(this.mediaIndex+(distance>0?1:-1));},{passive:true});

      const thumbs = document.createElement('div');

      thumbs.className = 'met-eternity__thumbs';

      thumbs.setAttribute('role','group');

      thumbs.setAttribute('aria-label',this.labels.choose_media);

      this.mediaItems.forEach((item,i)=>{

        const button = document.createElement('button');

        button.type = 'button';

        button.dataset.mediaIndex = i;

        button.className = 'met-eternity__thumb';

        button.setAttribute('aria-label',item.type==='video'?this.labels.video+' '+this.mediaItems.slice(0,i+1).filter(m=>m.type==='video').length:item.alt);

        const img = document.createElement('img');

        img.src = item.type==='video'?item.poster:item.url;

        img.alt = '';

        img.width = 88;

        img.height = 88;

        img.loading = 'lazy';

        button.append(img);

        if(item.type==='video') {

          const play = document.createElement('span');

          play.className = 'met-eternity__play';

          play.textContent = '▶';

          play.setAttribute('aria-hidden','true');

          button.append(play);

          const label = document.createElement('span');

          label.className = 'met-eternity__video-label';

          label.textContent = this.labels.video;

          button.append(label);

        }

        button.addEventListener('click',()=>this.showMedia(i));

        thumbs.append(button);

      });

      const caption = document.createElement('p');

      caption.className = 'met-eternity__caption';

      caption.dataset.mediaCaption = '';

      caption.setAttribute('aria-live','polite');

      gallery.append(stage,thumbs,caption);

      this.showMedia(0);

    }

    showMedia(index) {

      this.videoCleanup?.();

      this.mediaIndex = (index+this.mediaItems.length)%this.mediaItems.length;

      const item = this.mediaItems[this.mediaIndex];

      const area = this.querySelector('[data-active-media]');

      area.replaceChildren();

      if(item.type==='video') {

        const frame = document.createElement('iframe');

        const url = new URL(item.url);

        url.searchParams.set('autoplay','1');

        url.searchParams.set('muted','1');

        frame.src = url.href;

        frame.title = this.labels.video+' · '+item.caption;

        frame.allow = 'autoplay; fullscreen; picture-in-picture';

        frame.allowFullscreen = true;

        area.append(frame);

        const controls = document.createElement('div');

        controls.className = 'met-eternity__video-controls';

        const pause = document.createElement('button');

        pause.type = 'button';

        pause.textContent = this.labels.play;

        pause.disabled = true;

        let paused = true;

        const send = (method,value) => frame.contentWindow?.postMessage({method,...(value===undefined?{}:{value})},'https://player.vimeo.com');

        const update = value => {paused=value;pause.disabled=false;pause.textContent=value?this.labels.play:this.labels.pause;};

        const subscribe = () => {for(const name of ['play','pause','ended'])send('addEventListener',name);send('getPaused');};

        const receive = event => {

          if(event.origin!=='https://player.vimeo.com'||event.source!==frame.contentWindow)return;

          let message=event.data;

          if(typeof message==='string'){try{message=JSON.parse(message);}catch{return;}}

          if(message?.event==='ready')subscribe();

          if(message?.method==='getPaused')update(message.value);

          if(message?.event==='play')update(false);

          if(message?.event==='pause'||message?.event==='ended')update(true);

        };

        window.addEventListener('message',receive);

        frame.addEventListener('load',subscribe,{once:true});

        pause.addEventListener('click',()=>send(paused?'play':'pause'));

        const full = document.createElement('button');

        full.type = 'button';

        full.textContent = this.labels.full_video;

        let dialog;

        full.addEventListener('click',()=>{

          send('pause');

          dialog=document.createElement('dialog');

          dialog.className='met-eternity__video-dialog';

          dialog.setAttribute('aria-label',this.labels.video_full);

          const fullFrame=frame.cloneNode();

          fullFrame.title=this.labels.video_full;

          const close=document.createElement('button');

          close.type='button';close.className='met-eternity__video-close';

          close.textContent='×';close.setAttribute('aria-label',this.labels.close_video);

          close.addEventListener('click',()=>dialog.close());

          dialog.append(fullFrame,close);

          dialog.addEventListener('close',()=>{dialog.remove();dialog=null;full.focus();},{once:true});

          this.append(dialog);dialog.showModal();

        });

        controls.append(pause,full);

        area.append(controls);

        this.videoCleanup=()=>{window.removeEventListener('message',receive);dialog?.remove();this.videoCleanup=null;};

      } else {

        const image = document.createElement('img');

        image.src = item.url;

        image.alt = item.alt;

        if(item.modelReference)image.className='is-model-reference';

        image.width = 1200;

        image.height = 1200;

        image.decoding = 'async';

        area.append(image);

      }

      this.querySelectorAll('[data-media-index]').forEach((button,i)=>button.setAttribute('aria-pressed',String(i===this.mediaIndex)));

      this.querySelector('[data-media-count]').textContent = (this.mediaIndex+1)+' / '+this.mediaItems.length;

      this.querySelector('[data-media-caption]').textContent = item.caption||'';

    }

    disconnectedCallback(){this.videoCleanup?.();}

  }

  if(!customElements.get('met-eternity-aura'))customElements.define('met-eternity-aura',MetEternityAura);




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["met-eternity-product"] && !Shopify.designMode) return;
  try {
    



  class MetEternity extends HTMLElement {

    connectedCallback() {

      if (this.initialized) return;

      this.initialized = true;

      this.data = JSON.parse(this.querySelector('[data-eternity]').textContent || 'null');

      if (!this.data?.variants?.length) return;

      this.labels = JSON.parse(this.querySelector('[data-labels]').textContent);

      this.english = document.documentElement.lang.startsWith('en');

      this.german = (document.documentElement.lang.startsWith('de') || document.documentElement.lang === 'ar');

      const native = JSON.parse(this.querySelector('[data-native-variants]').textContent);

      this.data.variants.forEach(v=>{const n=native.find(n=>String(n.id)===String(v.id));if(n){v.available=n.available;v.price=n.price/100;}});

      this.selects = Array.from(this.querySelectorAll('[data-choice]'));

      this.selects[0].querySelectorAll('option').forEach(o=>o.textContent=this.metalName(o.value));

      const initial = this.data.variants.find(v => String(v.id) === this.dataset.initial) || this.data.variants[0];

      this.selects.forEach((s,i) => s.value = initial.options[i]);

      this.selects.forEach(s => s.addEventListener('change', () => this.update()));

      this.querySelectorAll('[data-metal]').forEach(r=>r.addEventListener('change',()=>{this.selects[0].value=r.value;this.update();}));

      this.classList.add('is-ready');

      this.update();

    }

    metalName(value){return this.labels[{'Platin':'platinum','14 Ayar Beyaz Altın':'white_gold','14 Ayar Sarı Altın':'yellow_gold','14 Ayar Pembe Altın':'rose_gold'}[value]]||value;}

    englishSpec(spec){

      const keys={'Metal':'Metal','Tasarım':'Design','Toplam karat seçeneği':'Total carat option','Gerçek toplam ağırlık':'Actual total weight','Ortalama genişlik':'Average width','Pırlanta türü':'Diamond type','Renk':'Colour','Berraklık':'Clarity','Markiz pırlantalar':'Marquise diamonds','Markiz kesim kalitesi':'Marquise cut grade','Yuvarlak pırlantalar':'Round diamonds','Mıhlama':'Setting','Rodyum kaplama':'Rhodium plated','Bilgi durumu':'Information status','Fiyat durumu':'Price status'};

      const values={'Çiçek motifli tamtur':'Floral full eternity','Laboratuvarda üretilmiş':'Lab grown','D–E (renksiz)':'D–E (colourless)','Tırnaklı':'Prong','Yok':'No','Var':'Yes','Tahmini taslak · doğrulama bekliyor':'Estimated draft · awaiting verification','3.195 USD · referans model fiyatı, doğrulanmadı':'USD 3,195 · reference model price, unverified'};

      const details=spec.details.map(([k,v])=>[keys[k]||k,this.metalName(values[v]||v).replaceAll(' adet',' stones').replaceAll(' toplam',' total').replaceAll('(tahmini)','(estimated)')]);

      const get=k=>details.find(([label])=>label===k)?.[1]||'';

      const estimated=details.some(([k])=>k==='Information status');

      const note=estimated?'ESTIMATED DRAFT: Size-specific source data has not been verified. Technical values and the USD 3,195 price are based on the 5 ct rose gold US 7.25 reference model and may vary by ring size. ':'';

      return {details,description:note+`MET Flora combines marquise and round lab-grown diamonds in a floral full eternity design. ${get('Metal')}, ${get('Total carat option')}: total diamond weight ${get('Actual total weight')}, average width ${get('Average width')}. Marquise diamonds: ${get('Marquise diamonds')}; round diamonds: ${get('Round diamonds')}. D–E colour, VS1 clarity, prong setting.`};

    }

    germanText(key, replacements = {}) {

      let text = this.labels.de[key];

      for (const [token, value] of Object.entries(replacements)) text = text.replaceAll('%' + token + '%', value);

      return text;

    }

    germanDetails(details) {

      const keys = {"Metal":"spec_metal","Design":"spec_design","Total carat option":"spec_total_carat_option","Actual total weight":"spec_actual_total_weight","Average width":"spec_average_width","Diamond type":"spec_diamond_type","Shape":"spec_shape","Colour":"spec_colour","Clarity":"spec_clarity","Marquise diamonds":"spec_marquise_diamonds","Marquise cut grade":"spec_marquise_cut_grade","Round diamonds":"spec_round_diamonds","Setting":"spec_setting","Rhodium plated":"spec_rhodium_plated","Information status":"spec_information_status","Price status":"spec_price_status","Diamond count":"spec_diamond_count","Cut grade":"spec_cut_grade","Ring size":"spec_ring_size","Source item total weight":"spec_source_item_total_weight","Source diamond total weight":"spec_source_diamond_total_weight","Individual diamond weight":"spec_individual_diamond_weight","Ring height":"spec_ring_height","Ring width top":"spec_ring_width_top"};

      const values = {"Floral full eternity":"value_floral_full_eternity","Shared-prong full eternity":"value_shared_prong_full_eternity","Eternity band":"value_eternity_band","Lab grown":"value_lab_grown","D–E (colourless)":"value_colourless","Prong":"value_prong","No":"value_no","Yes":"value_yes","Estimated draft · awaiting verification":"value_estimated_draft","USD 3,195 · reference model price, unverified":"value_unverified_price","Excellent":"value_excellent","Round":"value_round"};

      const metals = {'14K White Gold':'white_gold','14K Yellow Gold':'yellow_gold','14K Rose Gold':'rose_gold','Platinum':'platinum'};

      return details.map(([key,value]) => [this.labels.de[keys[key]] || key, this.labels.de[values[value]] || this.labels[metals[value]] || value.replaceAll(' stones',this.labels.de.value_stones).replaceAll(' total',this.labels.de.value_total).replaceAll('(estimated)',this.labels.de.value_estimated)]);

    }

    germanSpec(spec) {

      const source = this.englishSpec(spec);

      const details = this.germanDetails(source.details);

      const get = key => details.find(([label]) => label === this.labels.de[key])?.[1] || '';

      const estimated = source.details.some(([key]) => key === 'Information status');

      const note = estimated ? this.germanText('flora_estimated_note') : '';

      return {details,description:note + this.germanText('flora_description',{METAL:get('spec_metal'),CARAT:get('spec_total_carat_option'),WEIGHT:get('spec_actual_total_weight'),WIDTH:get('spec_average_width'),MARQUISE:get('spec_marquise_diamonds'),ROUND:get('spec_round_diamonds')})};

    }

    update() {

      const values = this.selects.map(s => s.value);

      this.querySelectorAll('[data-metal]').forEach(r=>r.checked=r.value===values[0]);

      const v = this.data.variants.find(v => v.options.every((o,i) => o === values[i]));

      const buy = this.querySelector('[data-buy]');

      if (!v) { buy.disabled = true; this.querySelector('[data-selection]').textContent = this.labels.missing; this.querySelector('[data-price]').textContent = ''; this.querySelector('[data-description]').textContent = ''; this.querySelector('[data-details]').replaceChildren(); this.querySelector('[data-gallery]').replaceChildren(); this.querySelector('[data-variant-id]').value = ''; this.gallerySignature = null; return; }

      this.querySelector('[data-variant-id]').value = v.id;

      buy.disabled = !v.available;

      buy.textContent = v.available ? this.labels.add : this.labels.unavailable;

      this.querySelector('[data-price]').textContent = new Intl.NumberFormat(this.german?'de-DE':this.english?'en-US':'tr-TR',{style:'currency',currency:'USD'}).format(v.price);

      this.querySelector('[data-selection]').textContent = [this.metalName(v.options[0]),...v.options.slice(1)].join(' · ') + ' · ' + v.sku;

      const originalSpec = this.data.specs[v.spec];

      const spec=this.german?this.germanSpec(originalSpec):this.english?this.englishSpec(originalSpec):originalSpec;

      this.querySelector('[data-description]').textContent = spec.description + ' '+this.labels.selected_size+': ' + v.options[2] + '.';

      const dl = this.querySelector('[data-details]');

      dl.replaceChildren();

      for (const [label,value] of [...spec.details,[this.labels.size,v.options[2]],[this.labels.sku,v.sku]]) { const dt=document.createElement('dt'),dd=document.createElement('dd');dt.textContent=label;dd.textContent=value;dl.append(dt,dd); }

      const group = this.data.galleries[v.gallery];

      const signature = JSON.stringify(group);

      if (signature !== this.gallerySignature) {

        this.gallerySignature = signature;

        this.renderGallery(group);

      }

      const url=new URL(location.href);url.searchParams.set('variant',v.id);history.replaceState({},'',url);

    }

    renderGallery(group) {

      if(this.german){

        group=structuredClone(group);

        const selected=this.selects.map(s=>s.value);

        group.images.forEach((im,i)=>{im.alt=`MET Flora ET001 · ${this.metalName(selected[0])} · ${selected[1]} · ${this.labels.de[['front_view','angled_view','model_reference'][i]||'reference_view']}`;im.caption=this.germanText(i<2?'flora_image_reference':selected[1]==='5 ct'?'flora_lifestyle_five':'flora_lifestyle_reference');});

        group.videos.forEach((video,i)=>video.caption=this.germanText(i===0?'flora_video_selected':'flora_video_reference'));

      }

      else if(this.english){

        group=structuredClone(group);

        const selected=this.selects.map(s=>s.value);

        group.images.forEach((im,i)=>{im.alt=`MET Flora ET001 · ${this.metalName(selected[0])} · ${selected[1]} · ${['front view','angled view','model reference'][i]||'reference view'}`;im.caption=i<2?'Images show the reference ring size; selected size specifications are listed in the product details.':selected[1]==='5 ct'?'Lifestyle reference shows the 3 ct model; it is not the exact appearance of the selected 5 ct ring.':'Lifestyle image is a model reference.';});

        group.videos.forEach((video,i)=>video.caption=i===0?'Video of the selected metal and carat model':'Shared lifestyle / model reference');

      }

      const gallery = this.querySelector('[data-gallery]');

      gallery.replaceChildren();

      this.mediaItems = group.images.slice(0,2).map(image => ({...image,type:'image'}));

      if(group.videos[0])this.mediaItems.push({...group.videos[0],type:'video',poster:group.videos[0].shopifyPoster||group.images[0]?.url});

      this.mediaItems.push(...group.images.slice(2).map(image => ({...image,type:'image'})));

      this.mediaItems.push(...group.videos.slice(1).map(video => ({...video,type:'video',poster:video.shopifyPoster||group.images.at(-1)?.url})));

      const stage = document.createElement('div');

      stage.className = 'met-eternity__stage';

      stage.tabIndex = 0;

      stage.setAttribute('role','region');

      stage.setAttribute('aria-label',this.labels.gallery);

      const media = document.createElement('div');

      media.className = 'met-eternity__active-media';

      media.dataset.activeMedia = '';

      stage.append(media);

      for(const [step,label,symbol] of [[-1,this.labels.previous,'‹'],[1,this.labels.next,'›']]) {

        const button = document.createElement('button');

        button.type = 'button';

        button.className = 'met-eternity__arrow ' + (step===-1?'is-prev':'is-next');

        button.setAttribute('aria-label',label);

        button.textContent = symbol;

        button.addEventListener('click',()=>this.showMedia(this.mediaIndex+step));

        stage.append(button);

      }

      const count = document.createElement('span');

      count.className = 'met-eternity__media-count';

      count.dataset.mediaCount = '';

      stage.append(count);

      stage.addEventListener('keydown',event=>{if(event.target!==stage)return;if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();this.showMedia(this.mediaIndex+(event.key==='ArrowRight'?1:-1));}});

      let touchStart;

      stage.addEventListener('touchstart',event=>touchStart=event.touches[0]?.clientX,{passive:true});

      stage.addEventListener('touchend',event=>{const distance=touchStart-event.changedTouches[0]?.clientX;if(Math.abs(distance)>50)this.showMedia(this.mediaIndex+(distance>0?1:-1));},{passive:true});

      const thumbs = document.createElement('div');

      thumbs.className = 'met-eternity__thumbs';

      thumbs.setAttribute('role','group');

      thumbs.setAttribute('aria-label',this.labels.choose_media);

      this.mediaItems.forEach((item,i)=>{

        const button = document.createElement('button');

        button.type = 'button';

        button.dataset.mediaIndex = i;

        button.className = 'met-eternity__thumb';

        button.setAttribute('aria-label',item.type==='video'?this.labels.video+' '+this.mediaItems.slice(0,i+1).filter(m=>m.type==='video').length:item.alt);

        const img = document.createElement('img');

        img.src = item.type==='video'?item.poster:item.url;

        img.alt = '';

        img.width = 88;

        img.height = 88;

        img.loading = 'lazy';

        if(item.type==='image' && i>1)img.className='is-model-reference';

        const thumbImage=document.createElement('span');

        thumbImage.className='met-eternity__thumb-image';

        thumbImage.append(img);

        button.append(thumbImage);

        if(item.type==='video') {

          const play = document.createElement('span');

          play.className = 'met-eternity__play';

          play.textContent = '▶';

          play.setAttribute('aria-hidden','true');

          button.append(play);

          const label = document.createElement('span');

          label.className = 'met-eternity__video-label';

          label.textContent = this.labels.video;

          button.append(label);

        }

        button.addEventListener('click',()=>this.showMedia(i));

        thumbs.append(button);

      });

      const caption = document.createElement('p');

      caption.className = 'met-eternity__caption';

      caption.dataset.mediaCaption = '';

      caption.setAttribute('aria-live','polite');

      gallery.append(stage,thumbs,caption);

      this.showMedia(0);

    }

    showMedia(index) {

      this.videoCleanup?.();

      this.mediaIndex = (index+this.mediaItems.length)%this.mediaItems.length;

      const item = this.mediaItems[this.mediaIndex];

      const area = this.querySelector('[data-active-media]');

      area.replaceChildren();

      if(item.type==='video' && item.shopifyUrl) {

        this.nativeVideoCache ||= new Map();

        let video=this.nativeVideoCache.get(item.shopifyUrl);

        if(!video){

          video=document.createElement('video');

          video.src=item.shopifyUrl;

          video.controls=true;

          video.playsInline=true;

          video.muted=true;

          video.preload='auto';

          video.poster=item.poster||'';

          video.style.cssText='display:block;width:100%;height:100%;object-fit:contain';

          video.setAttribute('aria-label',this.labels.video+' · '+(item.caption||''));

          this.nativeVideoCache.set(item.shopifyUrl,video);

        }

        area.append(video);

        video.play().catch(()=>{});

        this.videoCleanup=()=>{video.pause();this.videoCleanup=null;};

      } else if(item.type==='video') {

        const frame = document.createElement('iframe');

        const url = new URL(item.url);

        url.searchParams.set('autoplay','1');

        url.searchParams.set('muted','1');

        frame.src = url.href;

        frame.title = this.labels.video+' · '+item.caption;

        frame.allow = 'autoplay; fullscreen; picture-in-picture';

        frame.allowFullscreen = true;

        area.append(frame);

        const controls = document.createElement('div');

        controls.className = 'met-eternity__video-controls';

        const pause = document.createElement('button');

        pause.type = 'button';

        pause.textContent = this.labels.play;

        pause.disabled = true;

        let paused = true;

        const send = (method,value) => frame.contentWindow?.postMessage({method,...(value===undefined?{}:{value})},'https://player.vimeo.com');

        const update = value => {paused=value;pause.disabled=false;pause.textContent=value?this.labels.play:this.labels.pause;};

        const subscribe = () => {for(const name of ['play','pause','ended'])send('addEventListener',name);send('getPaused');};

        const receive = event => {

          if(event.origin!=='https://player.vimeo.com'||event.source!==frame.contentWindow)return;

          let message=event.data;

          if(typeof message==='string'){try{message=JSON.parse(message);}catch{return;}}

          if(message?.event==='ready')subscribe();

          if(message?.method==='getPaused')update(message.value);

          if(message?.event==='play')update(false);

          if(message?.event==='pause'||message?.event==='ended')update(true);

        };

        window.addEventListener('message',receive);

        frame.addEventListener('load',subscribe,{once:true});

        pause.addEventListener('click',()=>send(paused?'play':'pause'));

        const full = document.createElement('button');

        full.type = 'button';

        full.textContent = this.labels.full_video;

        let dialog;

        full.addEventListener('click',()=>{

          send('pause');

          dialog=document.createElement('dialog');

          dialog.className='met-eternity__video-dialog';

          dialog.setAttribute('aria-label',this.labels.video_full);

          const fullFrame=frame.cloneNode();

          fullFrame.title=this.labels.video_full;

          const close=document.createElement('button');

          close.type='button';close.className='met-eternity__video-close';

          close.textContent='×';close.setAttribute('aria-label',this.labels.close_video);

          close.addEventListener('click',()=>dialog.close());

          dialog.append(fullFrame,close);

          dialog.addEventListener('close',()=>{dialog.remove();dialog=null;full.focus();},{once:true});

          this.append(dialog);dialog.showModal();

        });

        controls.append(pause,full);

        area.append(controls);

        this.videoCleanup=()=>{window.removeEventListener('message',receive);dialog?.remove();this.videoCleanup=null;};

      } else {

        const image = document.createElement('img');

        image.src = item.url;

        image.alt = item.alt;

        if(this.mediaIndex>1)image.className='is-model-reference';

        image.width = 1200;

        image.height = 1200;

        image.decoding = 'async';

        area.append(image);

      }

      this.querySelectorAll('[data-media-index]').forEach((button,i)=>button.setAttribute('aria-pressed',String(i===this.mediaIndex)));

      this.querySelector('[data-media-count]').textContent = (this.mediaIndex+1)+' / '+this.mediaItems.length;

      this.querySelector('[data-media-caption]').textContent = item.caption||'';

    }

    disconnectedCallback(){this.videoCleanup?.();this.nativeVideoCache?.forEach(video=>{video.pause();video.removeAttribute('src');video.load();});this.nativeVideoCache?.clear();}

  }

  if(!customElements.get('met-eternity'))customElements.define('met-eternity',MetEternity);




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["met-home-video"] && !Shopify.designMode) return;
  try {
    

  function initializeMetHomeVideos() {

    document.querySelectorAll('.met-home-video').forEach((section) => {

      if (section.dataset.initialized) return;

      section.dataset.initialized = 'true';

      const video = section.querySelector('video');

      const button = section.querySelector('button');

      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');

      if (!video || !button || !video.querySelector('source')) return;

      const update = () => {

        section.classList.toggle('is-playing', !video.paused);

        button.setAttribute('aria-label', video.paused ? section.dataset.playLabel : section.dataset.pauseLabel);

      };

      const play = () => { video.play().catch(update); };

      if (section.querySelector('.met-home-video__de-localization')) {

        const markVideoFrame = () => section.classList.add('has-video-frame');

        video.addEventListener('playing', markVideoFrame);

        if (video.currentTime > 0) markVideoFrame();

      }

      video.muted = true;

      button.hidden = false;

      video.addEventListener('play', update);

      video.addEventListener('pause', update);

      button.addEventListener('click', () => { if (video.paused) play(); else video.pause(); });

      motion.addEventListener('change', () => { if (motion.matches) video.pause(); });

      update();

      if (!motion.matches) play();

    });

  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeMetHomeVideos);

  else initializeMetHomeVideos();

  document.addEventListener('shopify:section:load', initializeMetHomeVideos);


  } catch(e) { console.error(e); }
})();
})();
